<template>
  <div class="release_container">
    <div class="title">
      <i class="close_text cubeic-close" @click="showAlert"></i>
    </div>
    <div class="body">
      <textarea id="articleTitle" ref="articleTitle" class="article_border_none article_title" :maxlength="50"
                v-model="articleTitle" placeholder="填写标题会有更多互动哟~" @input="verifyNum('title')"></textarea>
      <div class="article_content">
        <pre class="article_con_pre" v-html="articleContent" :style="{maxHeight:imgList.length>0?'65px':'424px'}"></pre>
        <br>
        <textarea id="articleContent" style="min-height: 100px;" ref="articleContent" class="article_border_none"
                  :maxlength="10001"
                  v-model="articleContent" placeholder="写出你遇到的问题或想分享的经验" @input="verifyNum('con')"></textarea>
      </div>
      <div class="article_imgs">
        <div class="img_container img_item" v-for="(item,index) in imgList" @click="showImgPreview(index)" :key="index">
          <div class="close_btn" @click.stop="delImg(index)">×</div>
          <img :src="item" alt="">
        </div>
        <div class="upload_btn img_item" v-if="imgList.length<9 && imgList.length>0" @click="uploadImg">
          +
        </div>
      </div>
      <input type="file" name="upload" ref="uploadImgs" id="" style="display: none"  @change="preview()">
      <div class="popup_container">
        <w-popup :state="topicState" @handleClose="showTopic">
          <topic-list slot="content" :topicId="topicObj.id" :topicList="topicList"
                      @choiceTopic="choiceTopic"></topic-list>
        </w-popup>
      </div>

      <div class="big_img_container">
        <big-img-popup :state="bigImgState">
          <big-img slot="content" :state="bigImgState" :isDel="true" :imgIndex="imgIndex" :imgList="imgList"
                   @delImg="delImg" @closeBigImg="bigImgState=false"></big-img>
        </big-img-popup>
      </div>
      <vote v-if="vote" :data="vote" :show-close="true" @on-edit="showVote = true" scenario="new"/>
    </div>
    <div class="footer">
      <div class="article_topic" @click="showTopic">
        <div class="topic_tip" v-if="topicObj.id==-1">选择话题</div>
        <div class="topic_con">
          <span v-if="topicObj.id==-1" style="color: #BCBCBC;margin-left: 24px">选择合适的话题让更多人看到～</span>
          <div class="topic_item" v-else-if="topicObj.id!==null">
            <img src="https://files.wondercv.com/rn/bbs/topcimini.png" width="14" height="14" alt=""
                 style="margin-right: 5px">
            <span class="community-item-text">{{ topicObj.name }}</span>
          </div>
          <div class="topic_item_not" v-else>
            <i class="iconfont iconGroup2" style="font-size: 11px;margin-right: 9px"></i>不选择任何话题
          </div>
        </div>
        <div class="topic_icon">
          <i class="arrow cubeic-arrow"></i>
        </div>
      </div>
      <div class="footer_btn_container">
        <div class="img_upload" @click="uploadImg">
          <i class="iconfont icontupian"></i>
        </div>
        <div class="img_upload" @click="showVote = true">
          <i class="iconfont iconGroup4"></i>
        </div>
        <cube-button class="confirm_btn" :primary="true"
                     @click="debounce(setArticle,500)">发布
        </cube-button>
      </div>
    </div>
    <w-popup v-if="showVote" :state="showVote" @handleClose="showVote=false">
      <create-vote slot="content" @handleClose="showVote=false"></create-vote>
    </w-popup>
  </div>
</template>

<script>
  import WPopup from '../../../components/global/w-popup'
  import BigImgPopup from '../components/big-img-popup'
  import TopicList from './topic-list'
  import BigImg from './big-img'
  import bbs from '../../../api/api-list/bbs'
  import {dataURLtoBlob, blobToFile} from '../../../assets/js/utils'
  import {componentsMixin} from '../../../assets/js/mixin/components'
  import {envMixin} from "../../../assets/js/mixin/global";
  import {userMixin} from "../../../assets/js/mixin/user";
  import vote from "./create-vote";
  import {mapMutations, mapState, mapActions} from "vuex"
  import Vote from "./vote"
  import db from "../../../assets/js/db";
  import {formatImageWidthHeight} from "../../../assets/js/utils";
  const oss = require('ali-oss');
  import {uuid} from 'vue-uuid';

  export default {
    name: "release",
    mixins: [componentsMixin,envMixin,userMixin],
    props: {
      topicId: {
        type: Number,
        default: -1
      },
      state: Boolean,
      articeGroup: {
        type: Boolean,
        default: false
      }
    },
    components: {
      WPopup,
      BigImgPopup,
      TopicList,
      BigImg,
      CreateVote: vote,
      Vote
    },
    watch: {
      state: {
        async handler(state) {
          if (state) {
            this._phoneCallBack(this.showAlert);
            this.topicList = await this.getAllTopic();
            let list = this.topicList.filter(item => item.id == this.topicId);
            this.topicObj = list.length > 0 ? list[0] : {id: -1, name: "", image: ""};
            let draft = db.ls.get("draft")
            if (draft) {
              draft = JSON.parse(draft)
              this.articleContent = draft.articleContent
              this.topicObj = draft.topicObj
              this.articleTitle = draft.articleTitle
              this.imgList = draft.imgList
              this.setVote(draft.vote)
            }
            this.getOssConfig();
          }
        }
      }
    },
    data() {
      return {
        articleTitle: "",
        articleContent: "",
        imgList: [],
        topicState: false,
        bigImgState: false,
        imgIndex: 0,
        topicList: [],
        topicObj: {
          id: -1,
          name: "",
          image: ""
        },
        ossConfig: {}, // oss的配置
        showVote: false,//显示投票
      }
    },
    mounted() {

    },
    computed: {
      ...mapState('community', ["vote"])
    },
    methods: {
      ...mapMutations('community', ['setVote']),
      ...mapActions("user",['getShowUserDialog']),
      // 验证输入字数
      verifyNum(type) {
        if (type === 'title') {
          if (this.articleTitle.length >= 51) {
            this.$createToast({
              txt: '最多输入50字',
              time: 1500,
              type: 'txt'
            }).show()
            setTimeout(() => {
              this.articleTitle = this.articleTitle.slice(0, 50);
            }, 50)
          }
        } else {
          if (this.articleContent.length >= 10001) {
            this.$createToast({
              txt: '最多输入10000字',
              time: 1500,
              type: 'txt'
            }).show()
            setTimeout(() => {
              this.articleContent = this.articleContent.slice(0, 10000);
            }, 50)
          }
        }
      },
      // 显示大图
      showImgPreview(index) {
        this.imgIndex = index;
        this.bigImgState = true;
      },
      // 重置组件对象数据
      resetData() {
        this.articleTitle = '';
        this.articleContent = '';
        this.imgList = [];
        this.bigImgState = false;
        this.imgIndex = 0;
        this.topicState = false;
        this.topicList = [];
        this.ossConfig = {};
        this.topicObj = {
          id: -1,
          name: '',
          image: ''
        }
      },
      // 发布文章
      setArticle() {
        if (!this.articleContent) {
          this.$createToast({
            txt: '请输入发布内容',
            time: 1500,
            type: 'txt'
          }).show()
        } else {
          if (this.topicObj.id > -1) {
            let params = {
              title: this.articleTitle,
              content: this.articleContent,
              images: this.imgList,
              topic_id: this.topicObj.id,
              vote_id: this.vote ? this.vote.id : '',
              platform:this.isEnv
            }
            bbs.setArticle(params).then(async res => {
              if (res.code === 1000) {
                setTimeout(()=>{
                  this.getShowUserDialog(this.cvAccountToken)
                },500)
                this.setVote(null)
                await this._nullCallBack(null)
                await this.resetData();
                await this.$emit('closeRelease', 'success', res.data, 'scroll');
              } else {
                this.$createToast({
                  txt: res.message,
                  time: 1500,
                  type: 'warn'
                }).show()
              }
            })
          } else {
            this.$createToast({
              txt: '请选择话题',
              time: 1500,
              type: 'txt'
            }).show()
            this.topicState = true
          }
        }
      },
      // 删除图片
      delImg(index) {
        this.imgList.splice(index, 1);
        this.$createToast({
          txt: '删除成功',
          time: 1500,
          type: 'txt'
        }).show()
        if (this.bigImgState) this.bigImgState = false;
      },
      // 上传图片的回调
      async preview() {
        let file = this.$refs.uploadImgs.files
        if (file) {
          const reader = new FileReader()
          if (file[0].type !== 'image/png' && file[0].type !== 'image/gif' && file[0].type !== 'image/jpeg') {
            this.showToast('请选择正确的图片格式')
            return
          }
          reader.readAsDataURL(file[0])
          reader.onload = e => {
            let baseImg = reader.result;
            this.uploadOss(baseImg)
          }
        }
      },
      // 上传图片到阿里云
      async uploadOss(baseImg) {
        let store = await oss(this.ossConfig)
        let avatar = `${uuid.v1()}-avatar`;
        let blob = dataURLtoBlob(baseImg)
        let fileData = blobToFile(blob, avatar)
        try {
          let res = await store.put(`cv/profile/avatars/${avatar}`, fileData)
          if (res.res.statusCode !== 200) {
            this.$createToast({
              txt: '上传失败',
              time: 1000,
              type: 'warn'
            }).show()
            return
          }
          // let {url} = process.env.VUE_APP_ENV === 'local'?res.replace(/http:/g,'https:'):res;
          let {url} = res;
          let img = new Image();
          img.src = url
          img.onload = () => {
            this.imgList.push(url+`?width=${formatImageWidthHeight(img.width, img.height).w}&height=${formatImageWidthHeight(img.width, img.height).h}`)
          }
          this.$refs.uploadImgs.value = '';
        } catch (e) {
          console.log(e)
        }
      },
      // 点击上传
      uploadImg() {
        if (this.imgList.length >= 9) {
          this.$createToast({
            txt: '最多上传9张',
            time: 1000,
            type: 'warn'
          }).show()
        } else {
          this.$refs.uploadImgs.click()
        }
      },
      // 初始化oss参数
      async getOssConfig() {
        let res = await this.$api.cv.getOssConfig({
          marking: 'bbs'
        })
        if (res.code === 1000) {
          let {access_key_id, access_key_secret, expiration, request_id, security_token, bucket_name} = res.data
          this.ossConfig = {
            region: 'oss-cn-beijing',
            accessKeyId: access_key_id,
            accessKeySecret: access_key_secret,
            bucket: bucket_name,
            stsToken: security_token,
            secure: true
          }
        } else {
          this.$createToast({
            txt: '网络错误',
            time: 1000,
            type: 'warn'
          }).show()
        }
      },
      // 选择话题
      choiceTopic(obj) {
        this.topicObj = obj;
        this.topicState = false;
      },
      // 打开话题选择弹窗
      showTopic() {
        this.topicState = !this.topicState;
      },
      // 获取全部话题
      getAllTopic(params={}) {
        return new Promise((resolve, reject) => {
          bbs.getTopics({page: 1, size: 100,all:1}).then((res) => {
            if (res.code === 1000) {
              resolve(res.data.topics)
            } else {
              this.$createToast({
                txt: '网络错误',
                time: 1000,
                type: 'warn'
              }).show()
            }
          })
        })
      },
      // 关闭弹窗
      async showAlert() {
        if (this.state) {
          if (this.topicObj.id === -1 && !this.articleContent && !this.articleTitle && this.imgList.length === 0 && !this.vote) {
            await this._nullCallBack(null)
            await this._phoneCallBack(this.showAlert)
            await this.closeRelease()
          } else {
            this.$createDialog({
              type: 'confirm',
              title: '提示',
              content: '离开前是否需要保存草稿？',
              confirmBtn: {
                text: '保存草稿',
                active: true,
                disabled: false,
                href: 'javascript:;'
              },
              cancelBtn: {
                text: '不保存',
                active: false,
                disabled: false,
                href: 'javascript:;'
              },
              onConfirm: () => {
                console.log("保存草稿")
                this.saveDraft()
                this._phoneCallBack(this.showAlert)
              },
              onCancel: async () => {
                await this.closeRelease()
              }
            }).show()
          }
        }
      },
      closeRelease() {
        this.resetData();
        this.setVote(null)
        db.ls.remove('draft')
        this.$emit('closeRelease')
      },
      //保存到本地
      saveDraft() {
        let draft = {
          articleContent: this.articleContent,
          topicObj: this.topicObj,
          articleTitle: this.articleTitle,
          imgList: this.imgList,
          vote: this.vote ? this.vote : null
        }
        db.ls.set('draft', JSON.stringify(draft))
        this.$emit('closeRelease')
      }
    }
  }
</script>

<style lang="scss">
  .cube-dialog-confirm {
    .cube-dialog-btns {
      .cube-dialog-btn {
        color: #404040;
      }

      .cube-dialog-btn_highlight {
        color: #FF6644;
      }
    }
  }
</style>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";

  .release_container {
    width: 100%;
    height: 100vh;
    background-color: #fff;

    .title {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      //border-bottom: 1px solid #F4F4F4;
      .close_text {
        font-size: $font-size-large;
        color: rgb(141, 142, 143);
        margin-left: 24px;
        font-weight: bold;
      }
    }

    .body {
      width: 100%;
      height: calc(100% - 177px);
      padding: 0 24px;
      overflow: auto;
      //.scroll-list-wrap{
      //    height: 50px!important;
      //}
      .article_border_none {
        width: 100%;
        border: none;
        outline: none;
        resize: none;
        color: #404040;

        //overflow-y: visible;
      }

      .article_title {
        font-size: 16px;
        border-bottom: 1px solid #f9f9f9 !important;
        height: 16px;
        padding-top: 16px;
        padding-bottom: 11px;

        &::placeholder {
          color: #bcbcbc;
        }
      }

      .article_content {
        width: 100%;
        height: auto;
        max-height: 420px;
        overflow-y: auto;
        overflow-x: hidden;
        min-height: 34px;
        margin-top: 10px;
        position: relative;
        font-size: 14px;

        .article_con_pre {
          height: auto;
          width: 100%;
          min-height: 65px;
          line-height: 24px;
          max-height: 424px;
          padding: 2px;
          display: block;
          visibility: hidden;
          overflow: hidden;
        }

        #articleContent {
          width: 100%;
          height: 100%;
          line-height: 28px;
          font-size: 14px;
          position: absolute;
          top: 0;
          left: 0;

          &::placeholder {
            color: #bcbcbc;
          }
        }

        .text_nums {
          color: #ccc;
          position: absolute;
          right: 10px;
          bottom: -20px;
        }
      }

      .article_imgs {
        width: 100%;
        height: auto;
        margin-top: 25px;
        margin-bottom: 16px;
        display: flex;
        flex-wrap: wrap;
        //justify-content: space-between;
        .img_container {
          width: 105px;
          height: 105px;
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          overflow: hidden;
          position: relative;
          //background-color: #00feff;
          .close_btn {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            line-height: 19px;
            text-align: center;
            font-size: 18px;
            color: rgba(255, 255, 255, 0.3);
            background: rgba(0, 0, 0, 0.5);
            position: absolute;
            top: 6px;
            right: 6px;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .img_item:nth-child(1), .img_item:nth-child(4), .img_item:nth-child(7) {
          margin-left: 0;
        }

        .upload_btn {
          width: 105px;
          height: 105px;
          border-radius: 5px;
          margin-top: 5px;
          margin-left: 5px;
          border: 1px solid #ECECEC;
          color: #BCBCBC;
          font-size: 20px;
          line-height: 105px;
          text-align: center;
          cursor: pointer;
        }
      }

      .popup_container {
        width: 100vw;
        //height: 100vh;
      }
    }

    .footer {
      width: 100%;
      height: 131px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      position: fixed;
      left: 0;
      bottom: 0;

      .article_topic {
        width: 100%;
        height: auto;
        min-height: 30px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 0 24px;
        //border-top: 1px solid #F4F4F4;
        margin-top: 10px;
        position: relative;

        .topic_tip {
          color: #404040;
        }

        .topic_con {
          .topic_item_not{
            width: auto;
            height: 25px;
            padding: 0 10px;
            display: flex;
            align-items: center;
            color: #BCBCBC;
            font-size: 14px;
          }
          .topic_item {
            width: auto;
            height: 25px;
            padding: 0 10px;
            display: flex;
            align-items: center;
            border-radius: 13px;
            background-color: rgb(255, 246, 244);
            color: #FF6644;

            .icons {
              width: 17px;
              height: 17px;
              line-height: 17px;
              border-radius: 50%;
              background-color: #FF6644;
              color: #fff;
              text-align: center;
            }

            .topic_name {
              font-size: 12px;
              margin-left: 6px;
            }
          }
        }

        .arrow {
          position: absolute;
          right: 24px;
          color: #bcbcbc;
          top: calc(50% - 8px);
        }
      }

      .footer_btn_container {
        width: 100%;
        display: flex;
        height: 42px;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px;

        .img_upload {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background-color: #F9F9F9;
          color: #9c9c9c;
          line-height: 42px;
          text-align: center;
          margin-right: 14px;
          //font-size: 20px;
          //background: url("../../../assets/images/thum.png") no-repeat;
          //background-size: 100% 100%;
        }

        .cube-btn_disabled::after {
          border: none;
        }

        .confirm_btn {
          flex: 1;
          height: 42px;
          background-color: #FF6644;
          //margin-top: 10px;
          padding: 0;
          line-height: 42px;
          border-radius: 21px;
        }
      }
    }
  }
</style>